export const messages = {
  // Modals
  modals: {
    title: {
      confirmUnclaim: "Are you sure to unclaim the appliance?",
      confirmTestFeed: "Are you sure you want to run this test?",
    },
    description: {
      unclaimDescription: "Something related to uncalim",
    },
    note: {
      setCustomer: "Set as default",
    },
  },

  //   Need to bring all hardcoded string here. ...
};
